import useBiofluxMasters from '@/hooks/api/useBiofluxMasters';

export default function MastersLoader() {
  useBiofluxMasters();

  return null;
}
